import { render, staticRenderFns } from "./PagesList.vue?vue&type=template&id=8879e12c"
import script from "./PagesList.vue?vue&type=script&lang=js"
export * from "./PagesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports